/**
 * @author LB
 * @description 公共组件
 */
import glBreadcrumb from './glBreadcrumb';
import glIcon from './glIcon';
import glInputDisabled from './glInputDisabled';
import glOperateMenu from './glOperateMenu';
import glAudioPreview from './glAudioPreview';

export default {
  install: function (Vue) {
    Vue.component('gl-breadcrumb', glBreadcrumb);
    Vue.component('gl-icon', glIcon);
    Vue.component('gl-input-disabled', glInputDisabled);
    Vue.component('gl-operate-menu', glOperateMenu);
    Vue.component('gl-audio-preview', glAudioPreview);
  },
};
